export default __webpack_public_path__ + "static/media/Nihilistic Cowl.886f9168.jpg";